import React from 'react';
import { Link } from 'react-router-dom';

const ListCard = ({ list }) => {
  const progressText = list.total_options < 2
    ? 'Add at least 2 options'
    : `${list.comparisons_made} comparisons made`;

  return (
    <Link to={`/lists/${list.id}`} className='text-decoration-none text-reset'>
      <div className="card h-100">
        <div className="card-body d-flex flex-column">
          <h5 className="card-title">{list.name}</h5>
          <p className="card-text text-muted">{progressText}</p>
        </div>
      </div>
    </Link>
  );
};

export default ListCard;
